import { Grid } from "@mui/material";
import React from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { WSTabs } from "../../Components/Tabs/WSTabs";
import DistrictManager from "./DistrictManager";
import BlockManager from "./BlockManager";
import CDSManager from "./CdsManager";

export const MainSwitch: React.FC<any> = React.memo((props) => {
  const { control, setValue } = useForm<any>();
  const { tab } = useParams()
  const tabNum = Number(tab) || 0
  const tabsData: any[] = [
    { label: 'Districts', content: <DistrictManager /> },
    { label: 'Blocks', content: <BlockManager /> },
     { label: 'CDS', content: <CDSManager /> },
  ];
  return (
    <>
      <Grid container spacing={2}>
        <WSTabs id="contacttabs" setValue={setValue} selectedTab={tabNum} control={control} name="tabs" tabs={tabsData} justifyTabs="flex-start" />
      </Grid>
    </>
  )
})

